const subheadingActiveClass = 'NavList__subheading--active';
const closeDelay = 500;

let timer;

export default () => {
  document.addEventListener(
    'mouseenter',
    (e) => {
      if (!(e.target instanceof Element)) return;
      const el = e.target.closest('[data-nav-subheading]');
      if (el) {
        window.clearTimeout(timer);
        document.querySelectorAll('[data-nav-subheading]').forEach((subheading) => {
          subheading.classList.remove(subheadingActiveClass);
        });
        el.classList.add(subheadingActiveClass);
      }
    },
    true,
  );

  document.addEventListener(
    'mouseleave',
    (e) => {
      if (!(e.target instanceof Element)) return;
      const el = e.target.closest('[data-nav-subheading]');
      if (el) {
        timer = setTimeout(() => {
          el.classList.remove(subheadingActiveClass);
        }, closeDelay);
      }
    },
    true,
  );

  document.addEventListener(
    'mouseenter',
    (e) => {
      if (!(e.target instanceof Element)) return;
      const el = e.target.closest('[data-nav-sublist]');
      if (el) {
        window.clearTimeout(timer);
      }
    },
    true,
  );
};
